const storeThen = new Map();
const storeCatch = new Map();

const clone = obj => {
  return obj == null ? null : 'clone' in obj ? obj.clone() : { ...obj };
};

const cachedFetch = (url, ...args) => {
  const cachedThen = storeThen.get(url);
  const cachedCatch = storeCatch.get(url);

  // .clone()'s below are so the body is reusable
  return cachedThen
    ? new Promise(resolve => {
        storeThen.set(url, clone(cachedThen));
        resolve(cachedThen);
      })
    : cachedCatch
    ? new Promise((_, reject) => {
        storeCatch.set(url, clone(cachedCatch));
        reject(cachedCatch);
      })
    : new Promise((resolve, reject) => {
        fetch(url, ...args)
          .then(response => {
            storeThen.set(url, clone(response));
            resolve(response);
          })
          .catch(response => {
            storeCatch.set(url, clone(response));
            reject(response);
          });
      });
};

export default cachedFetch;
